import { render, staticRenderFns } from "./AgeGroupSpecialties.vue?vue&type=template&id=4f935878"
import script from "./AgeGroupSpecialties.vue?vue&type=script&lang=js"
export * from "./AgeGroupSpecialties.vue?vue&type=script&lang=js"
import style0 from "./AgeGroupSpecialties.vue?vue&type=style&index=0&id=4f935878&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports